module.exports = __webpack_public_path__ + "static/media/world.6ab933b9.svg";